/**
 * TanStack Query hooks for `ab-testing-creatives-landing-pages`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	abTestingCreativesLandingPagesQueryKeys,
	type CreateAbTestingCreativesLandingPagesBody,
	type ListAbTestingCreativesLandingPagesResponse,
	type AbTestingCreativesLandingPagesRow,
} from "./api";

export function useAbTestingCreativesLandingPagesList(): UseQueryResult<ListAbTestingCreativesLandingPagesResponse, Error> {
	return useQuery({
		queryKey: abTestingCreativesLandingPagesQueryKeys.list(),
		queryFn: list,
	});
}

export function useAbTestingCreativesLandingPagesCreate(): UseMutationResult<AbTestingCreativesLandingPagesRow, Error, CreateAbTestingCreativesLandingPagesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: abTestingCreativesLandingPagesQueryKeys.all });
		},
	});
}

export function useAbTestingCreativesLandingPagesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: abTestingCreativesLandingPagesQueryKeys.all });
		},
	});
}
